import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, ItemMiddleAttrListDataSet, TableDataColumn } from '@mri/types';

@Pipe({
  name: 'tableCellMiddleRender'
})
export class TableDataSetMiddleRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string | number | boolean | null {
    if(!prop.prevElement) return null;

    const value = this._getValue(prop, column);

    if (typeof value === 'number') return value.toFixed(2);

    return value;
  }

  private _getValue(prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string | number | boolean | null {
    if (typeof column.getMiddleValue === 'function') return column.getMiddleValue(prop);

    return null;
  }

}
